import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CommonHttpService } from './http.service';
import { OauthService } from './oauth.service';
import { UrlService } from './url.service';

/**
 * Client files at the account area (Engine backend). The store gate
 * `account-file-upload-enabled` decides whether any of this is reachable; the
 * API answers `enabled: false` when the store is off, and 404 on write.
 */
@Injectable()
export class AccountFilesService {
    constructor(
        protected http: CommonHttpService,
        protected rawHttp: Http,
        protected oauth: OauthService,
        protected urlService: UrlService
    ) {}

    /** Published file fields, the current file of each one and the store limits. */
    public list(clientId: number): Observable<Response> {
        return this.http.useAuth().get(`account/clients/${+clientId}/files`);
    }

    /** Remove the file of a field (record and S3 object). */
    public remove(clientId: number, extraFieldId: number): Observable<Response> {
        return this.http.useAuth().delete(
            `account/clients/${+clientId}/files/${+extraFieldId}`
        );
    }

    /**
     * Send (or replace) the file of a field.
     *
     * This is the only call that does NOT go through CommonHttpService: that
     * service always serializes the body as JSON and forces
     * `Content-Type: application/json`, which cannot carry a multipart upload.
     * Here the Content-Type header is deliberately omitted so the browser
     * writes the multipart boundary itself. CommonHttpService is untouched.
     */
    public upload(
        clientId: number,
        extraFieldId: number,
        file: File
    ): Observable<Response> {
        const body = new FormData();
        body.append('file', file, file.name);

        const headers = new Headers({
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `Bearer ${this.oauth.getToken()}`
        });

        return this.rawHttp.post(
            this.urlService.build(
                `account/clients/${+clientId}/files/${+extraFieldId}`
            ),
            body,
            new RequestOptions({ headers: headers })
        );
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/services/account-files.service.ts